const envExample = {
    name: '豫见太康出行',
    logo: '/images/yjtk.jpg',
    AMap: {
        key: '5ab240851fee5cd55f03b930807460fa'
    },
    isPosSwitch: false,//false不允许切换商户,true允许商户切换
}
export default envExample;
